import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Login from './views/Auth/LoginView'
import Master from './theme/AppMaster'
import SideBar from './theme/AppSideBar'
import useUserRefreshToken from './components/General/refreshToken'
import AutoLogoutWrapper from './components/AutoLogoutWrapper' // Importamos el nuevo wrapper
import './App.css'
import './environments/URL'

function App() {
  const [user, setUser] = useState(localStorage.getItem('token'))
  const [menu, setMenu] = useState(JSON.parse(localStorage.getItem('usuarioMenu')))

  useUserRefreshToken() // descomentar cuando quiten corse error

  useEffect(() => {
    const loggedUserJson = localStorage.getItem('token')
    setMenu('')
    if (loggedUserJson) {
      setUser(loggedUserJson)
    }
  }, [])

  return (
    <>
      {
        user === null
          ?
          <Router>
            <Routes>
              <Route path={global.ROUTE_LOGIN} name="Home" element={<Login />} />
              <Route path={global.ROUTE_ANY} name="Login" element={<Login />} />
            </Routes>
          </Router>
          :
          <AutoLogoutWrapper>
            <Router>
              <Routes>
                <Route path={global.ROUTE_HOME} name="Home" element={<Master />} />
              </Routes>
            </Router>
            <SideBar menu={menu} />
          </AutoLogoutWrapper>
      }
    </>
  )
}

export default App
